module.exports = __webpack_public_path__ + "assets/img/signature_ciardha.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/signature_ciardha.png
// module id = 1977
// module chunks = 0